import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1de4ab4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = { class: "step-number" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "step-description" }, "CHOOSE YOUR COLOURS", -1))
const _hoisted_5 = { class: "section" }
const _hoisted_6 = { class: "section-header" }
const _hoisted_7 = { class: "color-thumbnail" }
const _hoisted_8 = {
  key: 0,
  class: "color-options"
}
const _hoisted_9 = ["onClick", "title"]
const _hoisted_10 = {
  key: 1,
  class: "color-options"
}
const _hoisted_11 = ["onClick", "title"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "section-header" }
const _hoisted_14 = { class: "color-thumbnail" }
const _hoisted_15 = {
  key: 0,
  class: "color-options"
}
const _hoisted_16 = ["onClick", "title"]
const _hoisted_17 = {
  key: 1,
  class: "color-options"
}
const _hoisted_18 = ["onClick", "title"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "section-header" }
const _hoisted_21 = { class: "color-thumbnail" }
const _hoisted_22 = {
  key: 0,
  class: "color-options"
}
const _hoisted_23 = ["onClick", "title"]
const _hoisted_24 = {
  key: 1,
  class: "color-options"
}
const _hoisted_25 = ["onClick", "title"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "section-header" }
const _hoisted_28 = { class: "color-thumbnail" }
const _hoisted_29 = { class: "color-options" }
const _hoisted_30 = ["onClick", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "STEP " + _toDisplayString(_ctx.activeSidebarOption ? _ctx.activeSidebarOption.stepNumber : ""), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Accordion, { activeIndex: -1 }, {
        default: _withCtx(() => [
          _createVNode(_component_AccordionTab, { header: "BASE COLOURS" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(" PRIMARY "),
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.changableColors.primary.primary_1.name) + " ", 1),
                    _createElementVNode("div", {
                      class: "color-square",
                      style: _normalizeStyle({
                    'background-color': _ctx.changableColors.primary.primary_1.color,
                  })
                    }, null, 4)
                  ])
                ]),
                (_ctx.productType === 'truckercap')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.truckerHatColors.primary_1, (color, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => (
                  _ctx.changeColor(_ctx.changableColors.primary.primary_1.id, color)
                ),
                          key: index,
                          class: "color-square",
                          style: _normalizeStyle({ 'background-color': color.value }),
                          title: color.name
                        }, null, 12, _hoisted_9))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorOptions, (color, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => (
                  _ctx.changeColor(_ctx.changableColors.primary.primary_1.id, color)
                ),
                          key: index,
                          class: "color-square",
                          style: _normalizeStyle({ 'background-color': color.value }),
                          title: color.name
                        }, null, 12, _hoisted_11))
                      }), 128))
                    ]))
              ]),
              (_ctx.changableColors.primary.primary_2.color !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createTextVNode(" SECONDARY "),
                      _createElementVNode("div", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_ctx.changableColors.primary.primary_2.name) + " ", 1),
                        _createElementVNode("div", {
                          class: "color-square",
                          style: _normalizeStyle({
                    'background-color': _ctx.changableColors.primary.primary_2.color,
                  })
                        }, null, 4)
                      ])
                    ]),
                    (_ctx.productType === 'truckercap')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.truckerHatColors.primary_2, (color, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              onClick: ($event: any) => (
                  _ctx.changeColor(_ctx.changableColors.primary.primary_2.id, color)
                ),
                              key: index,
                              class: "color-square",
                              style: _normalizeStyle({ 'background-color': color.value }),
                              title: color.name
                            }, null, 12, _hoisted_16))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorOptions, (color, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              onClick: ($event: any) => (
                  _ctx.changeColor(_ctx.changableColors.primary.primary_2.id, color)
                ),
                              key: index,
                              class: "color-square",
                              style: _normalizeStyle({ 'background-color': color.value }),
                              title: color.name
                            }, null, 12, _hoisted_18))
                          }), 128))
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.areSecondaryColorsAvailable)
            ? (_openBlock(), _createBlock(_component_AccordionTab, {
                key: 0,
                header: "DETAILS COLOURS"
              }, {
                default: _withCtx(() => [
                  (_ctx.changableColors.secondary.secondary_1.color !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createTextVNode(" PRIMARY "),
                          _createElementVNode("div", _hoisted_21, [
                            _createTextVNode(_toDisplayString(_ctx.changableColors.secondary.secondary_1.name) + " ", 1),
                            _createElementVNode("div", {
                              class: "color-square",
                              style: _normalizeStyle({
                    'background-color':
                      _ctx.changableColors.secondary.secondary_1.color,
                  })
                            }, null, 4)
                          ])
                        ]),
                        (_ctx.productType === 'truckercap')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.truckerHatColors.secondary_1, (color, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  onClick: ($event: any) => (
                  _ctx.changeColor(_ctx.changableColors.secondary.secondary_1.id, color)
                ),
                                  key: index,
                                  class: "color-square",
                                  style: _normalizeStyle({ 'background-color': color.value }),
                                  title: color.name
                                }, null, 12, _hoisted_23))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorOptions, (color, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  onClick: ($event: any) => (
                  _ctx.changeColor(_ctx.changableColors.secondary.secondary_1.id, color)
                ),
                                  key: index,
                                  class: "color-square",
                                  style: _normalizeStyle({ 'background-color': color.value }),
                                  title: color.name
                                }, null, 12, _hoisted_25))
                              }), 128))
                            ]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.changableColors.secondary.secondary_2.color !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createTextVNode(" SECONDARY "),
                          _createElementVNode("div", _hoisted_28, [
                            _createTextVNode(_toDisplayString(_ctx.changableColors.secondary.secondary_2.name) + " ", 1),
                            _createElementVNode("div", {
                              class: "color-square",
                              style: _normalizeStyle({
                    'background-color':
                      _ctx.changableColors.secondary.secondary_2.color,
                  })
                            }, null, 4)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorOptions, (color, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              onClick: ($event: any) => (
                  _ctx.changeColor(_ctx.changableColors.secondary.secondary_2.id, color)
                ),
                              key: index,
                              class: "color-square",
                              style: _normalizeStyle({ 'background-color': color.value }),
                              title: color.name
                            }, null, 12, _hoisted_30))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}